
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * A component that redirects from the legacy /insights/:countryCode route 
 * to the new /cards/:countryCode route
 */
const InsightsToCardsRedirect = () => {
  const { countryCode } = useParams<{ countryCode: string }>();
  return <Navigate to={`/cards/${countryCode}`} replace />;
};

export default InsightsToCardsRedirect;
